jQuery.ajaxSetup({
    beforeSend: function(jqXHR, settings) {
        if(window.location.toString().split(':3000').length == 2) {
            if(settings.url.substr(0,4) == 'http') {
                settings.url = settings.url.split(':8000').join(':3000');
            } else {
                settings.url = window.location.toString().split(':3000')[0]+":3000"+settings.url;
            }
            var host = window.location.toString().split(':3000')[0];
            host = host.split('://')[1];

            var url_host = settings.url.split(':3000')[0];
            url_host = url_host.split('://')[1];

            if(host != url_host) {
                settings.url = settings.url.split(url_host).join(host);
            }
        }
    }
});